import { __extends } from "tslib";
import React from 'react';
import { getFinalStyle } from '../sharedBetweenInfoComponents';
var Description = /** @class */ (function (_super) {
    __extends(Description, _super);
    function Description() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Description.prototype.render = function () {
        var description = this.props.description;
        return (React.createElement("div", { className: 'info-member info-element-description', "data-hook": "item-description", style: getFinalStyle(this.props) }, description.split('\n').map(function (i, key) {
            return (React.createElement("span", { key: key },
                i,
                React.createElement("br", null)));
        })));
    };
    return Description;
}(React.Component));
export default Description;
//# sourceMappingURL=Description.js.map